import { useState } from "react";
import { Place, EVENT_TYPES } from "shared/topchef.types";

export interface MyAccountFirstConnectionProps {
  loggedInPlace: Place,
  updateAcount: (place: Place) => void;
}

const MyAccountFirstConnection = (props: MyAccountFirstConnectionProps) => {

  interface MyAccountForm {
    maxGuests: number;
    budget: number;
    acceptReward: boolean;
    supportedEventTypes: string[]
  }

  const [formData, setFormData] = useState<MyAccountForm>({
    maxGuests: props.loggedInPlace.maxGuests,
    budget: props.loggedInPlace.budget,
    acceptReward: props.loggedInPlace.acceptReward,
    supportedEventTypes: props.loggedInPlace.supportedEventTypes
  });
  const [termsAccepted, setTermsAccepted] = useState(false);

  const handleTermsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTermsAccepted(event.target.checked);
  };

  const handleInputEventChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const name = event.target.name;
    
    let value: string | boolean = event.target.value;
    if (name === "acceptReward") {
      value = JSON.parse(value.toLowerCase());
    }

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };


  const handleCheckboxChange = (value: string) => {
    setFormData((prev) => ({
      ...prev,
      supportedEventTypes: prev.supportedEventTypes.includes(value)
        ? prev.supportedEventTypes.filter((item) => item !== value)
        : [...prev.supportedEventTypes, value],
    }));
  };
  
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const placeToUpdate: Place = {
      id: props.loggedInPlace.id,
      name: props.loggedInPlace.name,
      wpId: props.loggedInPlace.wpId,
      firstConnection: false,
      city: props.loggedInPlace.city,
      region: props.loggedInPlace.region,
      maxGuests: Number(formData.maxGuests),
      budget: formData.budget,
      acceptReward: formData.acceptReward,
      supportedEventTypes: formData.supportedEventTypes,
      locHallPoints: 0
    };

   props.updateAcount(placeToUpdate);

  };

  return (
      <div className="page-final-profil-settings page-profil container p-5 overflow-auto">

        <div id="welcome_message" className="card rounded p-3 mb-4 border-success">
            <h5 className="m-0 text-success">Bienvenue sur EventLink !</h5>
        </div>
        <h5 className="mb-3">Finaliser le paramétrage du votre profil</h5>


          <form className="card shadow-sm p-4 align-items-center" onSubmit={handleSubmit}>                        
              <div id="commission_acceptance" className="mb-4 text-center">
                  <p className="fw-semibold mb-2">Votre lieu accepte-t-il les commissions et peut-il en reverser ?</p>
                  
                  <div className="d-flex gap-3 justify-content-center">
                      <input type="radio" id="accept_commissions" name="acceptReward" value="true" className="btn-check" required defaultChecked={formData.acceptReward} onChange={handleInputEventChange} />
                      <label className="btn btn-outline-success" htmlFor="accept_commissions">Oui</label>
                      <input type="radio" id="refuse_commissions" name="acceptReward" value="false" className="btn-check" required defaultChecked={formData.acceptReward === false} onChange={handleInputEventChange} />
                      <label className="btn btn-outline-danger" htmlFor="refuse_commissions">Non</label>
                  </div>
              </div>
      
              <div id="event_types" className="mb-4">
                  <p className="fw-semibold text-center">Quel(s) type(s) d'événement souhaitez-vous recevoir ? <i>(Sélection multiple)</i></p>
                  <div id="event_types_list" className="d-flex flex-wrap gap-2">
                    {EVENT_TYPES.map((eventType) => (
                      <div key={eventType.value}>
                        <input type="checkbox" className="btn-check" id={eventType.value} value={eventType.value} autoComplete="off" name="supportedEventTypes" checked={formData.supportedEventTypes.includes(eventType.value)} onChange={() => handleCheckboxChange(eventType.value)}/>
                        <label className="btn btn-outline-primary" htmlFor={eventType.value}>{eventType.label}</label>
                      </div>
                    ))}
                  </div>
              </div>
          
              <div id="budget_container" className="mb-3 col-md-6 text-center justify-content-center">
                  <label htmlFor="budget" className="form-label fw-semibold">Votre budget minimum pour un événement</label>
                  <input type="number" id="budget" name="budget" className="form-control w-20 m-auto" placeholder="Montant HT en €" required min="0" value={formData.budget} onChange={handleInputEventChange} />
              </div>

              <div id="invites_container" className="mb-3 col-md-6 text-center justify-content-center">
                  <label htmlFor="maxGuests" className="form-label fw-semibold">Nombre maximum d'invités que vous pouvez acceuillir</label>
                  <input type="number" id="maxGuests" name="maxGuests" className="form-control w-20 m-auto" placeholder="Capacité maximale" required min="0" value={formData.maxGuests} onChange={handleInputEventChange} />
              </div>

              <div id="accept_terms_of_service_container" className="mb-3 col-md-8 text-center justify-content-center" data-testid="accept_terms_of_service">
                <input type="checkbox" id="terms_of_use" className="m-2 mb-0 mt-0" autoComplete="off" required name="accept_terms_of_use" checked={termsAccepted} onChange={handleTermsChange} />
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid*/}
                <label htmlFor="terms_of_use" className="form-label">J'accepte <a href="https://loc-hall.fr/conditions-de-referencement-prestataires/" target="_blank" rel="noreferrer">les conditions de référencement</a> et <a href="https://loc-hall.fr/charte-de-bonne-conduite-eventlink/" target="_blank" rel="noreferrer">la charte de bonne conduite</a> d'EventLink</label>
              </div>

              <div className="mt-2 text-center btn-list">
                  <button id="save_profil_settings" className="btn btn-primary" disabled={(termsAccepted===false)}>Enregistrer</button>
              </div>
          </form>
          
      </div>
  );

}

export default MyAccountFirstConnection;
